module.exports = __webpack_public_path__ + "static/media/ru.f9def64d.svg";